import { Money } from '@afterpay/types'

export { Country } from '@afterpay/types'

export enum CheckoutMode {
  EXPRESS = 'EXPRESS',
  STANDARD = 'STANDARD',
}

// All known backend error codes, see
// https://github.com/AfterpayTouch/pay-later/blob/master/core/core-domain/src/main/java/com/touch/paylater/core/exceptions/ErrorCode.java
export enum ErrorCode {
  Error = 'error',
  NotFound = 'not_found',
  Unauthorized = 'unauthorized',
  InvalidObject = 'invalid_object',
  MethodNotAllowed = 'method_not_allowed',
  InvalidJson = 'invalid_json',
  ForcePasswordResetRequired = 'force_password_reset_required',
  AuthenticationDeclined = 'authentication_declined',
  AuthenticationFailure = 'authentication_failure',
  AuthenticationFailureMaxAttempts = 'authentication_failure_max_attempts',
  AccountLocked = 'account_locked',
  AccountDisabled = 'account_disabled',
  AccountClosed = 'account_closed',
  AccountSuspended = 'account_suspended',
  AccountFrozen = 'account_frozen',
  ProfileRefreshOverduePending = 'profile_refresh_overdue_pending',
  profileRefreshOverdueRequired = 'profile_refresh_overdue_required',
  Forbidden = 'forbidden',
  AmountTooHigh = 'amount_too_high',
  OrderAmountTooHigh = 'order_amount_too_high',
  OverduePayments = 'overdue_payments',
  OverduePaymentsCheckoutPaymentEligible = 'overdue_payments_checkout_payment_eligible',
  ChargebackPending = 'chargeback_pending',
  UnsupportedPaymentMethod = 'unsupported_payment_method',
  InsufficientFunds = 'insufficientFunds',
  InvalidAmount = 'invalid_amount',
  InvalidPreorder = 'invalid_preorder',
  UnsupportedOrder = 'unsupported_order',
  PreconditionFailed = 'precondition_failed',
  CardNotAccepted = 'card_not_accepted',
  PostcodeNotRecognized = 'postcode_not_recognized',
  UnsupportedPaymentType = 'unsupported_payment_type',
  Conflict = 'conflict',
  NoDataAvailable = 'no_data_available',
  DuplicateEmail = 'duplicate_email',
  InvalidMerchantUserStatus = 'invalid_merchant_user_status',
  InvalidOrderTransactionStatus = 'invalid_order_transaction_status',
  InvalidConsumerAccountStatus = 'invalid_consumer_account_status',
  AdjustedOrderAmountTooLow = 'adjusted_order_amount_too_low',
  AdjustedOrderAmountTooHigh = 'adjusted_order_amount_too_high',
  RecentPassword = 'recent_password',
  PasswordExpired = 'password_expired',
  UnsupportedCardType = 'unsupported_card_type',
  UnsupportedCardIssuer = 'unsupported_card_issuer',
  UnsupportedCardIssuerBank = 'unsupported_card_issuer_bank',
  FailedToSaveSmsVerificationCode = 'failed_to_save_sms_verification_code',
  FailedToSaveSaveOrderTransactionData = 'failed_to_save_save_order_transaction_data',
  SmsVerificationCodeGenerationMaximumReached = 'sms_verification_code_generation_maximum_reached',
  FailedToSendSmsVerificationCode = 'failed_to_send_sms_verification_code',
  FailedToSendEmailVerificationCode = 'failed_to_send_email_verification_code',
  FailedToSendSmsInvite = 'failed_to_send_sms_invite',
  InvalidSmsCode = 'invalid_sms_code',
  InvalidEmailCode = 'invalid_code',
  InvalidEmailAddressMatch = 'email_different_from_one_code_sent_to',
  SmsVerificationCodeValidationMaximumReached = 'sms_verification_code_validation_maximum_reached',
  SmsVerificationCodeGenerationNotAllowed = 'sms_verification_code_generation_not_allowed',
  EmailVerificationCodeGenerationNotAllowed = 'email_verification_code_generation_not_allowed',
  SmsCodeNotFound = 'sms_code_not_found',
  EmailCodeExpired = 'email_code_not_found',
  MaxSmsCodeAttempts = 'max_sms_code_attempts',
  MaxEmailCodeAttempts = 'max_email_code_attempts',
  PaymentVerificationFailure = 'payment_verification_failure',
  UnexpectedState = 'unexpected_state',
  MaxActiveOrdersReached = 'max_active_orders_reached',
  InviteCodeNotFound = 'invite_code_not_found',
  RegistrationCodeNotFound = 'registration_code_not_found',
  InvalidNewPassword = 'invalid_new_password',
  MobileDifferentFromOneSmsCodeSentTo = 'mobile_different_from_one_sms_code_sent_to',
  SmsMessagingNotEnabled = 'sms_messaging_not_enabled',
  InvalidCode = 'invalid_code',
  ConcurrentPaymentAttempt = 'concurrent_payment_attempt',
  ExceedPreapproval = 'exceed_preapproval',
  Declined = 'declined',
  MinimumNotMet = 'minimum_not_met',
  ExistingPhoneNumber = 'existing_phone_number',
  ExistingPhoneNumberUnicorn = 'existing_phone_number_unicorn',
  ExistingPhoneNumberSendEmail = 'existing_phone_number_send_email',
  InvalidPhoneNumber = 'invalid_phone_number',
  VerifiedMobileMissing = 'verified_mobile_missing',
  ExistingDeviceSecret = 'existing_device_secret',
  PreApprovalDeclined = 'pre_approval_declined',
  PreApprovalNotActive = 'pre_approval_not_active',
  PreApprovalExpired = 'pre_approval_expired',
  InvalidToken = 'invalid_token',
  ExistingOrders = 'existing_orders',
  InvalidPaymentState = 'invalid_payment_state',
  OrderPaymentExpired = 'order_payment_expired',
  InvalidAmountNegative = 'invalid_amount_negative',
  CardNotEnabled = 'card_not_enabled',
  CardExpiry = 'card_expiry',
  CardHolderNameInvalid = 'card_holder_name_invalid',
  UnderAge = 'under_age',
  OverAge = 'over_age',
  UnableToProcessOrder = 'unable_to_process_order',
  UnableToProcessOrderTemporarily = 'unable_to_process_order_temporarily',
  ProbationLimitExceeded = 'probation_limit_exceeded',
  NotImplemented = 'not_implemented',
  PasswordResetDeclined = 'password_reset_declined',
  PasswordResetCodeGenerationNotAllowed = 'password_reset_code_generation_not_allowed',
  IncompleteConsumerProfile = 'incomplete_consumer_profile',
  UpdateConsumerProfileNotAllowed = 'update_consumer_profile_not_allowed',
  PasswordResetCodeInvalid = 'password_reset_code_invalid',
  PasswordResetCodeMaxAttempts = 'password_reset_code_max_attempts',
  PasswordResetNotAllowed = 'password_reset_not_allowed',
  PasswordResetTwoFactorChallengesInvalid = 'password_reset_two_factor_challenges_invalid',
  PasswordResetTwoFactorChallengesMaxAttempts = 'password_reset_two_factor_challenges_max_attempts',
  WeakPassword = 'weak_password',
  IdenticalPassword = 'identical_password',
  FailedToProcessOtpRequest = 'failed_to_process_otp_request',
  InvalidPreApprovalStatus = 'invalid_pre_approval_status',
  UnexpectedPreApprovalSource = 'unexpected_pre_approval_source',
  MoneyOrdersDisabled = 'money_orders_disabled',
  ConsumerSubscriptionFailure = 'consumer_subscription_failure',
  DeclinedDueToCountryOrigin = 'declined_due_to_country_origin',
  UnsupportedCurrency = 'unsupported_currency',
  IdentityCheckLimitExceeded = 'identity_check_limit_exceeded',
  IdentityCheckRejected = 'identity_check_rejected',
  IdentityCheckGatewayError = 'identity_check_gateway_error',
  IdCheckRequired = 'id_check_required',
  DuplicateIdentity = 'duplicate_identity',
  IdentityAlreadyVerified = 'identity_already_verified',
  HighRiskNationality = 'high_risk_nationality',
  StandaloneDeviceExpected = 'standalone_device_expected',
  NotMerchantDevice = 'not_merchant_device',
  DeviceNotActive = 'device_not_active',
  FailedToSendCode = 'failed_to_send_code',
  MaxAttemptsReached = 'max_attempts_reached',
  MaxAttemptsReachedForType = 'max_attempts_reached_for_type',
  VerificationCodeExpired = 'verification_code_expired',
  AddressSuburbRequired = 'address_suburb_required',
  AddressStateInvalid = 'address_state_invalid',
  AddressStateIneligible = 'address_state_ineligible',
  PostcodeInvalid = 'postcode_invalid',
  AddressPoBoxNotAllowed = 'address_po_box_not_allowed',
  EmailExistsInAnotherRegion = 'email_exists_in_another_region',
  ApprovalPending = 'approval_pending',
  CantTurnComplianceFlagOff = 'cant_turn_compliance_flag_off',
  MerchantNotEnabled = 'merchant_not_enabled',
  MerchantComplianceVerificationNotCompleted = 'merchant_compliance_verification_not_completed',
  MerchantChannelSetupError = 'merchant_channel_setup_error',
  MerchantChannelNotConfiguredForOrderSource = 'merchant_channel_not_configured_for_order_source',
  InvalidEmailAddress = 'invalid_email_address',
  UnsupportedMerchantTradingCountry = 'unsupported_merchant_trading_country',
  UnsupportedMerchantAddressCountry = 'unsupported_merchant_address_country',
  NotMerchantOrder = 'not_merchant_order',
  InvalidCountryCode = 'invalid_country_code',
  InvalidLocalAreaOrVillageName = 'invalid_local_area_or_village_name',
  InvalidAddress = 'invalid_address',
  VerificationNotPerformed = 'verification_not_performed',
  ProviderError = 'provider_error',
  OauthUnregisteredClient = 'oauth_unregistered_client',
  OauthDisabledClient = 'oauth_disabled_client',
  OauthInvalidScopes = 'oauth_invalid_scopes',
  OauthInvalidGrantType = 'oauth_invalid_grant_type',
  OauthBadCredentials = 'oauth_bad_credentials',
  OauthInvalidAuthCode = 'oauth_invalid_auth_code',
  OauthInvalidClientId = 'oauth_invalid_client_id',
  OauthInvalidRedirectUrl = 'oauth_invalid_redirect_url',
  OauthInvalidOrExpiredAccessToken = 'oauth_invalid_or_expired_access_token',
  OauthInvalidRefreshToken = 'oauth_invalid_refresh_token',
  OauthConsumerRevokedAccess = 'oauth_consumer_revoked_access',
  RejectedByFraud = 'rejected_by_fraud',
  VerificationCodeGenerationNotAllowed = 'verification_code_generation_not_allowed',
  OrderAlreadyExists = 'order_already_exists',
  PaymentCaptured = 'payment_captured',
  PaymentVoided = 'payment_voided',
  PaymentExpired = 'payment_expired',
  PaymentDeclined = 'payment_declined',
  PreviousOrderRequired = 'previous_order_required',
  NoOutstandingPayments = 'no_outstanding_payments',
  Login2faRequired = 'login_2fa_required',
  Login2faRequiredNoEmail = 'login_2fa_required_no_email',
  OrderDiscountWrongCurrency = 'order_discount_wrong_currency',
  InvalidState = 'invalid_state',
  LowInventory = 'low_inventory',
  MerchantUserAlreadyLinked = 'merchant_user_already_linked',
  MerchantUserInvalidStandalonePosDevice = 'merchant_user_invalid_standalone_pos_device',
  PosCardNotAvailableInState = 'pos_card_not_available_in_state',
  PosCardOrdersNotRefundableViaApi = 'pos_card_orders_not_refundable_via_api',
  ChangePaymentScheduleNotNextUpcomingPayment = 'change_payment_schedule_not_next_upcoming_payment',
  ChangePaymentScheduleRestrictedPayments = 'change_payment_schedule_restricted_payments',
  ChangePaymentScheduleTooCloseToDueDate = 'change_payment_schedule_too_close_to_due_date',
  ChangePaymentSchedulePaymentOverdue = 'change_payment_schedule_payment_overdue',
  ChangePaymentScheduleMerchantBlacklisted = 'change_payment_schedule_merchant_blacklisted',
  ChangePaymentScheduleMaxChangesOnOrder = 'change_payment_schedule_max_changes_on_order',
  ChangePaymentScheduleMaxChangesInDuration = 'change_payment_schedule_max_changes_in_duration',
  ChangePaymentScheduleAccountTooNew = 'change_payment_schedule_account_too_new',
  ChangePaymentScheduleAccountHardship = 'change_payment_schedule_account_hardship',
  BadRequest = 'bad_request',
  PosCardOrdersNotVoidableViaApi = 'pos_card_orders_not_voidable_via_api',
  IneligibleState = 'ineligible_state',
  RefundAmountExceedsAvailableAmount = 'refund_amount_exceeds_available_amount',
  UnsupportedLocale = 'unsupported_locale',
  RefundTimelimitExceeded = 'refund_timelimit_exceeded',
  InvalidReturnDate = 'invalid_return_date',
  AddPaymentActiveCardLimitExceeded = 'add_payment_active_card_limit_exceeded',
  AddPaymentInactiveCardLimitExceeded = 'add_payment_inactive_card_limit_exceeded',
  MerchantOrderAmountLimitExceeded = 'merchant_order_amount_limit_exceeded',
  RiskDeclineUnclassified = 'risk_decline_unclassified',
  ExcessiveLateFeeAmount = 'excessive_late_fee_amount',
  ExcessiveLateFeeNumber = 'excessive_late_fee_number',
  NoValidPaymentSource = 'no_valid_payment_source',
  TooManyOTPRequests = 'too_many_otp_requests',
  InvalidPickupAddress = 'invalid_pickup_address',
  OAuthInvalidRedirectUrl = 'oauth_invalid_redirect_url',
  OAuthUnregisteredClient = 'oauth_unregistered_client',
  OAuthDisabledClient = 'oauth_disabled_client',
  OAuthBadCredentials = 'oauth_bad_credentials',
  OAuthInvalidClientId = 'oauth_invalid_client_id',
  OAuthInvalidGrantType = 'oauth_invalid_grant_type',
  OAuthInvalidScopes = 'oauth_invalid_scopes',
  OAuthAccountAlreadyLinked = 'account_already_linked',
  CardScanRequired = 'card_scan_required',
  InvalidDobVerification = 'invalid_dob_verification',
  MaxDobVerificationAttempts = 'max_dob_verification_attempts',
  UnableToUpdateCheckout = 'unable_to_update_checkout',
  PaymentFailure = 'payment_failure',
  CreditCardProhibitedForPaymentType = 'credit_card_prohibited_for_payment_type',
  CheckoutConfirm2FARequired = 'checkout_confirm_2fa_required',
  CheckoutConfirm2FARequiredNoEmail = 'checkout_confirm_2fa_required_no_email',
  RiskDeclined = 'risk_declined',
  OrderLimitExceeded = 'order_limit_exceeded',
  StateRestrictionsPCL = 'ineligible_state_for_consumer_lending',
  IdentityVerificationDeclinedPCL = 'cl_identity_check_rejected',
  accountBalanceNonZero = 'account_balance_non_zero',
  accountAlreadyFrozen = 'account_already_frozen',
  accountHasSubscriptionOrders = 'account_has_subscription_orders',
  accountHasChargeAtShipOrders = 'account_has_charge_at_ship_orders',
  activeOrders = 'active_orders',
  InstallmentAmountsMismatch = 'installment_amounts_mismatch',
  RegistrationNotPermitted = 'registration_not_permitted',
  HardIdCollectionRequired = 'hard_id_collection_required',
  HardIdCollectionRequiredNoWaitResponse = 'hard_id_collection_required_no_wait_response',
  PaywatchCheckFailed = 'paywatch_check_failed',
  LimitTimesExceeded = 'dispute_times_limit_exceeded',
  DisputeCreatingTooEarly = 'dispute_creating_too_early',
  DisputeCreatingTooLate = 'dispute_creating_too_late',
  ComplianceDeclineBureauNoHit = 'compliance_decline_bureau_no_hit',
  ComplianceDeclineBureau = 'compliance_decline_bureau',
  ComplianceDeclineSystemError = 'compliance_decline_system_error',
  MerchantPayMonthlyOnly = 'merchant_pay_monthly_only',
  GiftCardIneligible = 'gift_card_ineligible',
  MerchantLimitZero = 'merchant_limit_zero',
  AccountPendingDeletion = 'account_pending_deletion',
  ExtendedFraudAlert = 'extended_fraud_alert',
  TooManyRequests = 'too_many_requests',
  EFACodeDeliveryFailure = 'efa_code_delivery_failure',
  EFACodeUnableToBeSaved = 'efa_code_unable_to_be_saved',
  EFACodeGenerationNotAllowed = 'efa_code_generation_not_allowed',
  EFACodeNotFound = 'efa_code_not_found',
  EFACodeInvalid = 'efa_code_invalid',
  EFACodeMaxAttempts = 'efa_code_max_attempts',
  LimitInternalError = 'limit_internal_error',
  CreditCheckFailure = 'credit_check_failure',
  OrderAmountExceedsSpendCap = 'order_amount_exceeds_spend_cap',
  ShadowAccountIneligible = 'shadow_account_ineligible',
  UnsuitabilityNotFound = 'unsuitability_not_found',
  UnsuitabilityExpired = 'unsuitability_expired',
  ContractAcceptanceRequired = 'contract_acceptance_required',
  InvalidQuestion = 'invalid_question',
  UnsuitabilityDecline = 'unsuitability_decline',
}

export interface PortalApiError {
  errorCode: ErrorCode
  errorId: string
  message: string
  httpStatusCode: number
  errorInfo?: ErrorInfo | any
}

export interface ErrorInfo {
  max_otb_amount?: Money
  max_otb_amount_without_down_payment?: Money
  number_of_active_orders?: string
  number_of_orders_to_be_paid?: string
  number_of_risk_declines?: string
  maximum_order_value?: string
  minimum_order_value?: string
  pay_monthly_only?: boolean
}

// @TODO: Remove and use generic error type in /types
export interface FetchBaseQueryErrorType {
  status: number
  data: PortalApiError
}

export const Tags = {
  PaymentSchedule: 'PaymentSchedule',
  CreditCards: 'CreditCards',
  PaymentReschedule: 'PaymentReschedule',
  AmountDueSummary: 'AmountDueSummary',
  OverduePayments: 'OverduePayments',
  OrderTransactions: 'OrderTransactions',
  MarketingPreferences: 'MarketingPreferences',
  CreditLimit: 'CreditLimit',
  BankAccounts: 'BankAccounts',
  PayableOrderTransactions: 'PayableOrderTransactions',
  CreditCheckConsentStatus: 'CreditCheckConsentStatus',
  BillingAgreements: 'BillingAgreements',
  CardScan: 'CardScan',
  Permissions: 'Permissions',
  PaymentArrangement: 'PaymentArrangement',
  Sessions: 'Sessions',
  OrderTransactionPpa: 'OrderTransactionPpa',
  ConsumerAccount: 'ConsumerAccount',
  Loyalty: 'Loyalty',
  BiometricPermissions: 'BiometricPermissions',
  ConsumerTags: 'ConsumerTags',
  ConsumerTagsWithData: 'ConsumerTagsWithData',
  Payday: 'Payday',
  CreditFacility: 'CreditFacility',
  CreditFacilitySummary: 'CreditFacilitySummary',
  BankingSessions: 'BankingSessions',
  IdentityBiometric: 'IdentityBiometric',
  CreditFacilityClose: 'CreditFacilityClose',
  CashAuth: 'CashAuth',
} as const
export type Tag = (typeof Tags)[keyof typeof Tags]

export type InvalidatesTags = Array<Tag | { type: Tag; id: string | number }>

/**
 * Types from each api
 */
export * from './payments/types'
export * from './identity/types'
export * from './consumer/types'
export * from './seon-data/types'
